import { useMemo } from 'react';

import type { ColGroupDef } from 'ag-grid-enterprise';

import type { MultisByGroup } from '@enterprise/api';

import NumberCellRenderer from '@components/grid/renderers/number-cell.renderer';

export const useGetMultisByGroupColumns = () => {
  return useMemo(() => {
    return [
      {
        field: 'mailingListGroupSequence',
        headerName: 'Group',
        hide: true,
        rowGroup: true,
        width: 400,
      },
      {
        children: [
          {
            cellDataType: 'number',
            field: 'mailingId',
            headerClass: ['bg-blue-900'],
            headerName: 'ID',
            hide: true,
            width: 125,
          },
        ],
        headerClass: ['bg-blue-950'],
        headerName: 'Mailing Information',
      },
      {
        children: [
          {
            cellClass: ['bg-green-200', 'text-green-900'],
            field: 'multi',
            filter: 'agNumberColumnFilter',
            headerClass: ['bg-green-800'],
            headerName: 'Multi',
            type: ['numericColumn'],
            width: 175,
          },
          {
            aggFunc: 'sum',
            cellClass: ['bg-green-300', 'text-green-900'],
            cellRenderer: NumberCellRenderer,
            field: 'quantityMultiCount',
            filter: 'agNumberColumnFilter',
            headerClass: ['bg-green-800'],
            headerName: 'Total Count',
            type: ['numericColumn'],
            width: 175,
          },
        ],
        headerClass: ['bg-green-950'],
        headerGroupComponentParams: {
          icon: 'fa-circle-check',
        },
        headerName: 'Total',
        headerTooltip: 'Percentage of the Received Quantity tha are Multis',
      },
    ] as ColGroupDef<MultisByGroup>[];
  }, []);
};
